(()=>{
function init(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const optionData=JSON.parse(root.querySelector('[data-pp-options]').textContent);
const initial=JSON.parse(root.querySelector('[data-pp-variant]').textContent);
const text=JSON.parse(root.querySelector('[data-pp-text]').textContent);
const form=root.querySelector('form'),button=form.querySelector('button'),hidden=form.querySelector('[data-variant-id]'),status=root.querySelector('[data-status]');
const bars=[...root.querySelectorAll('[data-bar]')],dart=root.querySelector('[data-dart]');
const label=(i)=>bars[i].querySelector('[data-size]').value+' / '+bars[i].querySelector('[data-color]').value;
if(initial.options?.length===3){
initial.options.forEach((raw,i)=>{const bar=raw.split(' + ')[0].split(' / ');if(bar.length===2){bars[i].querySelector('[data-size]').value=bar[0];bars[i].querySelector('[data-color]').value=bar[1];}});
dart.value=initial.options[2].endsWith(' + Green Machine')?'Green Machine':'Natural';
}
root.querySelectorAll('[data-pp-image]').forEach(thumb=>thumb.addEventListener('click',()=>{
const img=root.querySelector('.pp-tuna-main-image');img.removeAttribute('srcset');img.src=thumb.dataset.ppImage;
root.querySelectorAll('[data-pp-image]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));
}));
let abort,sequence=0;
const same=(a,b)=>a?.length===b.length&&a.every((v,i)=>v===b[i]);
function apply(v,wanted){
root.querySelector('[data-price]').textContent=v.price||'';
root.querySelector('[data-compare]').textContent=v.compare||'';
const valid=v.id&&v.available&&same(v.options,wanted);
hidden.value=valid?v.id:'';button.disabled=!valid;status.textContent=valid?text.available:text.sold_out;
if(valid){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState(null,'',url);}
}
async function update(){
const seq=++sequence;if(abort)abort.abort();abort=new AbortController();
hidden.value='';button.disabled=true;status.textContent=text.checking;
const wanted=[label(0),label(1),label(2)+' + '+dart.value];
const ids=wanted.map((v,i)=>optionData[i].values.find(x=>x.name===v)?.id);
if(ids.some(x=>!x)){status.textContent=text.error;return;}
try{
const url=new URL(root.dataset.productUrl,location.origin);
const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
url.searchParams.set('section_id',root.dataset.section);url.searchParams.set('option_values',ids.join(','));
const response=await fetch(url,{signal:abort.signal});if(!response.ok)throw Error('HTTP');
const doc=new DOMParser().parseFromString(await response.text(),'text/html');
const v=JSON.parse(doc.querySelector('[data-pp-variant]').textContent);
if(seq===sequence)apply(v,wanted);
}catch(e){if(e.name!=='AbortError'&&seq===sequence){status.textContent=text.error;button.disabled=true;hidden.value='';}}
}
form.addEventListener('change',update);
form.addEventListener('submit',e=>{if(button.disabled||!hidden.value)e.preventDefault();else{button.disabled=true;}});
const wanted=[label(0),label(1),label(2)+' + '+dart.value];
apply(initial,wanted);
}
document.querySelectorAll('.pp-tuna').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.pp-tuna').forEach(init));
})();